import * as tslib_1 from "tslib";
import { ElementRef, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocomplete } from '@angular/material';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { concat } from 'lodash';
import { Subject } from 'rxjs';
import { debounceTime, filter, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var FcSearchInputComponent = /** @class */ (function () {
    function FcSearchInputComponent(fuseTranslationLoaderService) {
        this.isLocationInput = false;
        this.showSearchIcon = false;
        this.showChevronIcon = false;
        this.requiredMark = false;
        this.preloadOptions = false;
        this.searchOnFocus = false;
        this.legacyStyle = false;
        this.validation = [];
        this.isDuplicatedForm = false;
        this.enableInfiniteScroll = false;
        this.options = [];
        this.loading = false;
        this.optionsListOpened = false;
        this.googleCustomerAddressErrors = [];
        this.googleCustomerAddressWarnings = [];
        this.hasMoreOptions = true;
        this.optionsOffset = 0;
        this.searchTerm = new FormControl(null);
        this.removeSubscriptions = new Subject();
        this.optionsLimit = 10;
        fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    FcSearchInputComponent.prototype.ngOnDestroy = function () {
        this.removeSubscriptions.next();
        this.removeSubscriptions.complete();
    };
    FcSearchInputComponent.prototype.ngOnChanges = function (changes) {
        if (changes.validation && changes.validation.currentValue) {
            this.googleCustomerAddressErrors = changes.validation.currentValue.errors;
            this.googleCustomerAddressWarnings = changes.validation.currentValue.warnings;
        }
    };
    FcSearchInputComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (this.control.value && this.control.value.isAllSelected) {
                    this.control.setValue({ name: this.showAllOptionText, isAllSelected: true });
                }
                if (this.reload$) {
                    this.reload$.subscribe(function () {
                        _this.options = [];
                        _this.searchTerm.updateValueAndValidity({ emitEvent: true });
                    });
                }
                this.searchTerm.valueChanges
                    .pipe(takeUntil(this.removeSubscriptions), debounceTime(500), filter(function (value) { return typeof value === 'string'; }), map(function (value) { return value.trim().toLowerCase(); }), tap(function () { return _this.loading = true; }), switchMap(function () { return _this.search(_this.searchTerm.value, _this.optionsLimit, 0); }), tap(function () { return _this.loading = false; }))
                    .subscribe(function (options) {
                    _this.resetQueryParams();
                    if (!options) {
                        return;
                    }
                    _this.hasMoreOptions = options.length >= _this.optionsLimit;
                    var filteredOptions = (_this.sortOptionsFn && _this.sortOptionsFn(options)) || options;
                    if (!_this.searchTerm.value && _this.showAllOption) {
                        var allOption = { name: _this.showAllOptionText, isAllSelected: true };
                        _this.options = concat([allOption], filteredOptions);
                        return;
                    }
                    _this.options = filteredOptions;
                });
                this.control.valueChanges
                    .pipe(takeUntil(this.removeSubscriptions))
                    .subscribe(function (value) {
                    _this.displayText = _this.displayWith(value) || '';
                    if (value && _this.isLocationInput) {
                        _this.displayText = value.name;
                    }
                    if (!value) {
                        _this.searchTerm.setValue(null);
                    }
                });
                this.control.statusChanges
                    .pipe(takeUntil(this.removeSubscriptions))
                    .subscribe(function () {
                    if (_this.control.disabled) {
                        _this.searchTerm.disable();
                    }
                    else {
                        _this.searchTerm.enable();
                        _this.setPreLoadedItems();
                    }
                });
                this.displayText = this.displayText ? this.displayText : this.displayWith(this.control.value) || '';
                if (this.control.disabled) {
                    this.searchTerm.disable();
                }
                else {
                    this.searchTerm.enable();
                    this.setPreLoadedItems();
                }
                return [2 /*return*/];
            });
        });
    };
    FcSearchInputComponent.prototype.onFocus = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (this.searchOnFocus) {
                    this.searchTerm.setValue(this.searchTerm.value || '');
                }
                return [2 /*return*/];
            });
        });
    };
    FcSearchInputComponent.prototype.resetSearch = function () {
        this.searchTerm.setValue('');
    };
    FcSearchInputComponent.prototype.resetQueryParams = function () {
        this.optionsOffset = 0;
        this.hasMoreOptions = true;
    };
    FcSearchInputComponent.prototype.onOptionSelected = function (event) {
        var value = event && event.option && event.option.value;
        this.control.setValue(value || undefined);
    };
    FcSearchInputComponent.prototype.onOptionCleared = function () {
        var _this = this;
        this.control.setValue(undefined);
        this.searchTerm.setValue('');
        setTimeout(function () { return _this.inputElement.nativeElement.focus(); });
    };
    FcSearchInputComponent.prototype.onAutocompleteScroll = function () {
        var _this = this;
        this.optionsListOpened = true;
        if (this.options.length) {
            this.loading = false;
        }
        setTimeout(function () {
            if (_this.matAutocomplete &&
                _this.matAutocomplete.panel &&
                _this.matAutocomplete.panel.nativeElement) {
                _this.matAutocomplete.panel.nativeElement.scrollTo({
                    top: 0,
                });
                _this.scrollHandler = function (event) {
                    if (_this.hasMoreOptions && _this.enableInfiniteScroll) {
                        var _a = event.target, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
                        var marginOfError = 1;
                        if ((scrollTop + clientHeight) >= (scrollHeight - marginOfError)) {
                            _this.loading = true;
                            _this.optionsOffset += _this.optionsLimit;
                            _this.loadMoreOptions();
                        }
                    }
                };
                _this.matAutocomplete.panel.nativeElement.addEventListener('scroll', _this.scrollHandler);
            }
        });
    };
    FcSearchInputComponent.prototype.loadMoreOptions = function () {
        var _this = this;
        this.search(this.searchTerm.value, this.optionsLimit, this.optionsOffset).then((function (options) {
            var _a;
            (_a = _this.options).push.apply(_a, tslib_1.__spread(options));
            _this.loading = false;
            _this.hasMoreOptions = options.length >= _this.optionsLimit;
        }));
    };
    FcSearchInputComponent.prototype.setPreLoadedItems = function () {
        if (this.preloadOptions && !this.options.length) {
            this.searchTerm.setValue('');
        }
    };
    return FcSearchInputComponent;
}());
export { FcSearchInputComponent };
